// @ts-check
/** Observe an image exactly once, including cached and failed images; return cleanup.
 * @param {HTMLImageElement} image @param {()=>void} ready @param {()=>void} [failed]
 */
export function observeImage(image, ready, failed = () => {}) {
  let disposed = false;
  let settled = false;
  const load = () => { if (!disposed && !settled && image.naturalWidth > 0) { settled = true; ready(); } };
  const error = () => { if (!disposed && !settled) { settled = true; failed(); } };
  image.addEventListener('load', load); image.addEventListener('error', error);
  if (image.complete) queueMicrotask(image.naturalWidth > 0 ? load : error);
  return () => { disposed = true; image.removeEventListener('load', load); image.removeEventListener('error', error); };
}
